define('v3/Common/Services/Backend/gradeBackend',[
	'jquery',
	'lodash',
	'BackendBase'
], function ($, _, BackendBase) {
	function GradeBackend () {
		BackendBase.call(this);
	};

	GradeBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(GradeBackend.prototype, {
		getGradesForSchool: _.memoize(function () {
			return this._getJsonApi('Grades/GradesForSchool');
		})
	});

	return new GradeBackend();
});

